<!--
  File name: PBNEFList.vue
  Program Description:
    - This component renders the list of submitted PBNEF
    - Each item is clickable to view the a specific PBNEF

  Includes:
    - PBNEFListItem
    - Function that fetch all submitted PBNEF
-->
<template>
  <v-row
    v-if="loading"
    justify="center"
  >
    <v-btn
      text
      disabled
      :loading="loading"
    />
  </v-row>
  <span v-else-if="!loading && pbnefList.length">
    <template
      v-for="(item, idx) in pbnefList"
    >
      <PBNEFListItem
        :key="idx"
        :item="item"
        :disabled="isPic"
      />
    </template>
  </span>
  <v-card
    v-else
    align="center"
    class="pa-6"
  >
    <p>
      No existing PBNEF{{ type === 'Drafted' ? ' Draft ' : ' ' }}yet.
    </p>
  </v-card>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import crud from '@/utils/rest/crud'
import pbnefMixin from '@/mixins/pbnefMixin'
import PBNEFListItem from './PBNEFListItem.vue'

export default {
  name: 'ViewList',
  components: {
    PBNEFListItem
  },
  mixins: [pbnefMixin],
  props: {
    type: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapFields('pbnef', {
      pbnefList: 'pbnefList',
      dbnStatus: 'dbnStatus',
      dbnNumber: 'dbnNumber'
    }),
    isPic () {
      return this.$s.userRole.includes('pic')
    }
  },
  async mounted () {
    if (!this.dbnStatus.length) await this.getDbnStatus()
    await this.fetchPbnefList()
  },
  methods: {
    async fetchPbnefList () {
      this.loading = true
      const draft = this.dbnStatus.find(x => x.value === 'Drafted')

      let advancedQuery = {
        $and: [
          { status: { $ne: draft._id } },
          { docketNumber: this.dbnNumber }
        ]
      }

      if (this.$props.type === 'Drafted') {
        advancedQuery = {
          $and: [
            { status: draft._id },
            { docketNumber: this.dbnNumber }
          ]
        }
      }
      const dataview = 'table'
      const list = await crud('pbnef').list({ advancedQuery, dataview })
      if (list.ok) this.pbnefList = list.entries
      this.loading = false
    }
  }
}
</script>
